<template>
  <div class="wrapper">
    <div class="login">
      <p style="text-align: center; margin: 0; margin-bottom: 30px">
        <img
          src="https://pra.pspp-integrated.com/assets/img/logo.png"
          width="130"
        />
      </p>

      <form @submit.prevent="login">
        <div class="form-group">
          <label>USER</label>
          <select v-model="param.id">
            <option></option>
            <option v-for="(item, index) in user" :key="index" :value="item.id">
              {{ item.nama }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>PASSWORD</label>
          <input type="password" v-model="param.password" />
        </div>
        <div>
          <button
            type="submit"
            :disabled="loading"
            :class="{ disabled: loading }"
          >
            Login
          </button>
        </div>
        <p v-if="failed" style="color: #f00; margin-bottom: 0">Login Gagal</p>
      </form>
    </div>
  </div>
</template>

<script>
import * as api from "./../api/Api";

export default {
  name: "Home",
  data() {
    return {
      user: [],
      param: {},
      loading: false,
      failed: "",
    };
  },
  methods: {
    login() {
      this.loading = true;
      this.failed = "";

      this.param.platform = 'WISUDA';
      api
        .post("/v1/Users/login", this.param)
        .then((r) => {
          this.loading = false;
          if (r.valid === true) {
            this.$store.commit("settings/setUser", r.data);
            this.failed = "";

            location.href = "./index.html";
          } else {
            this.failed = "Login Gagal";
          }
        })
        .catch((e) => {
          this.loading = false;
          this.failed = "Kesalahan jaringan";
        });
    },
  },
  mounted() {
    api.get("/v1/Users/getByPlatform?platform=WISUDA").then((r) => {
      this.user = r;
    });
  },
};
</script>

<style scoped lang="scss">
div.wrapper {
  background: url("https://kbm.pspp-integrated.com/assets/img/bglogin.jpg")
    no-repeat center;
  background-size: cover;
  height: calc(100vh - 100px);
  padding-top: 100px;
}
.login {
  background: #fff;
  width: 400px;
  margin: 0 auto;
  border-radius: 6px;
  box-shadow: 0px 0px 10px #999;
  padding: 20px 20px 30px;

  h2 {
    text-align: center;
    line-height: 36px;
    margin: 30px 0px;
  }

  form {
    background: #fff;
    padding: 0px 30px;

    .form-group {
      margin-bottom: 15px;
      label {
        display: block;
        font-size: 14px;
        margin-bottom: 5px;
      }
      input,
      select {
        background: #fff;
        padding: 10px;
        width: calc(100% - 22px);
        border: 1px solid #ccc;
        border-radius: 4px;
        outline: none;
        &:focus {
          border: 1px solid #18bbea;
        }
      }

      select {
        width: 100%;
      }
    }

    button {
      background: #18bbea;
      width: 100%;
      padding: 15px;
      outline: none;
      border: 0;
      color: #fff;
      text-transform: uppercase;
      font-weight: 600;
      border-radius: 4px;

      &.disabled {
        background: #79cbe2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue